import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router'
import { apiClient } from '~/shared/api/data-ingestion-api'
import { DOCUMENT_SERVER_STATUS } from '../config'

const POLLING_INTERVAL = 5000

export function useDocumentProcessingPolling() {
  const documentKey = useParams<'documentKey'>().documentKey as string

  return useQuery({
    ...apiClient.getDocumentDocumentsKeyGetOptions({
      path: { key: documentKey },
    }),
    refetchInterval: (query) =>
      query.state.data?.document.review_status === DOCUMENT_SERVER_STATUS.processing
        ? POLLING_INTERVAL
        : false,
  })
}
